export enum JobStatus {
  Provisioning = "provisioning",
  Activating = "activating",
  Running = "running",
  Stopped = "stopped",
  NoWorkload = "no_workload",
}

export const JOB_STATUSES = Object.values(JobStatus);
